import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { RoutesConstants, RolesConstants, ConfigConstant } from '@shared/constants';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { LayoutService } from '../../../../layout/services/layout.service';
import { User } from '@features/users/models/user.model';
import { UserStatus } from '../../enums/shared-enums.enum';
import { BaseComponent } from '../../components/base-component/base.component';
import { UserType } from '../../enums/shared-enums.enum';
import { ActivatedRoute } from '@angular/router';
import { UserApi } from '@shared-features/services/user-api.service';
@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent extends BaseComponent implements OnInit {
  @Input() userType: UserType;
  id: number;
  @Output() showDetails = new EventEmitter();
  @ViewChild('resetPasswordModal') resetPasswordModal;

  dataSource: MatTableDataSource<User>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public displayedColumns: string[] = ['code', 'name', 'email', 'mobileNumber', 'roles', 'status', 'shippingType', 'updatedAt', 'action'];

  userStatus = UserStatus;
  sharedConstants = RoutesConstants;
  RolesConstants = RolesConstants;

  currentUsers: User[] = [];
  originalUsers: User[] = [];

  //pagination
  pageSize: number = ConfigConstant.PAGE_SIZE;
  pageIndex: number = 1;
  offset: number = ConfigConstant.INIT_PAGE_OFFSET;
  totalRowsCount: number;
  UserType = UserType;

  constructor(public layoutService: LayoutService, private activatedRoute: ActivatedRoute, private userApi: UserApi) {
    super();
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params?.id;
    this.loadUsers();
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  onSearch(value: string) {
    this.dataSource.filter = value?.trim().toLowerCase() || '';
    this.totalRowsCount = this.dataSource.filteredData.length;
  }

  onSelectStatus(filterValue: string) {
    this.dataSource.data = this.getCurrentUsers(this.offset, this.pageSize * this.pageIndex);
    this.dataSource.data = this.dataSource.data.filter((user) => {
      if (filterValue === UserStatus.All) return true;
      else return user.status === filterValue;
    });
    this.totalRowsCount = this.dataSource.filteredData.length;
  }

  onPageIndexChange(index: number) {
    this.pageIndex = index;
    this.offset = (this.pageIndex - 1) * this.pageSize;
    this.dataSource.data = this.getCurrentUsers(this.offset, this.pageSize * this.pageIndex);
  }

  setupTable(users: User[]) {
    this.originalUsers = users;
    this.dataSource = new MatTableDataSource<User>(this.getCurrentUsers(0, this.pageSize));
    this.totalRowsCount = users.length;
    this.dataSource.sort = this.sort;
    this.sort.direction = 'desc';
    this.sort.active = 'updatedAt';
    this.sort.sortChange.emit(this.sort);
    this.dataSource.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].toString().toLocaleLowerCase();
  }

  getCurrentUsers(fromIndex: number, toIndex: number): User[] {
    return this.originalUsers.slice(fromIndex, toIndex);
  }

  loadUsers() {
    this.load(this.userApi.getAllUsers(this.userType, this.id), {
      fetchOnce: true,
      emptyContentCheck: (res) => !res?.length,
      isLoadingTransparent: true,
    }).subscribe(
      (users) => {
        this.setupTable(users);
      }
    );
  }
}
